module.exports = __webpack_public_path__ + "media/images/pic/popup/icon-book-53e79bf103cc2682e9460f2c32cb2e5d.png";